import { unpack } from '../../utils/index.js';

const rgb2num = (...args) => {
    const [r, g, b] = unpack(args, 'rgb');
    return (r << 16) + (g << 8) + b;
};

export default rgb2num;



//////////////////
// WEBPACK FOOTER
// ./node_modules/chroma-js/src/io/num/rgb2num.js
// module id = 2514
// module chunks = 6